import * as API from './apiBase';

let baseList = {
    GetBlacklistList: 'api/Blacklist/GetBlacklistList',
    ImportBlacklist: 'api/Blacklist/Import',
    DelBlacklist: 'api/Blacklist/DelBlacklist',
}

export const GetTemplateFile = 'api/Blacklist/GetTemplateFile'

export const ImportPreviewCompensation = 'api/Blacklist/ImportPreview'

export const ExportPreviewCompensation = 'api/Blacklist/Export'

/*获取黑名单列表 */
export const GetBlacklistList = (Name, VATNo, language, PageIndex, PageSize) => {
    return API.POST(baseList.GetBlacklistList, {
        Name,
        VATNo,
        language,
        PageIndex,
        PageSize
    })
};
/*删除黑名单列表 */
export const DelBlacklist = (Id, language) => {
    return API.POST(baseList.DelBlacklist + '?Id=' + Id, {
        language
    })
};
/* 导入黑名单 */
export const ImportBlacklist = (list, language) => {
    return API.POST(baseList.ImportBlacklist, list)
};
